module.exports = __webpack_public_path__ + "media/app/images/messages_cta-b04bea4ef34afaeeb91b7d2244b7413a.png";